import ownerDocument from './ownerDocument.js';

/* eslint-env browser */

function ownerWindow(node) {
  const doc = ownerDocument(node);
  return doc.defaultView || window;
}

export { ownerWindow as default };
//# sourceMappingURL=ownerWindow.js.map
